module.exports = __webpack_public_path__ + "static/cpp-logo-7894299772a549becc0989607f1fdd24.png";